export enum PrismicSliceType {
  TopTeaser = 'top_teaser_v2',
  TopBanner = 'top_banner_v2',
}

export enum ImageContainerType {
  Big = 'big',
  Slim = 'slim',
}
